import { gql, NetworkStatus, useQuery } from '@apollo/client'

import {
  CurrentUserFragmentDoc,
  GalleryPostsFragmentDoc,
  GalleryPostsQuery,
  GalleryPostsQueryVariables,
  PostType,
  StoryFilter,
} from '@/clients/utoniq-core/schema'
import { config } from '@/config'
import { useRouter } from '@/core'

/**
 *
 */
export const useGalleryList = ({ categoryId }: { categoryId: string }) => {
  const { router } = useRouter<{ artistId: string }>()
  const artistId = router.query.artistId ?? config.artistId
  const variables = {
    artistId,
    pageInput: { limit: 15 }, // NOTE: utoniqPaginationのmerge処理に必要なため残す
    pageInputById: { limit: 15 },
    resourceTypes: [PostType.Image, PostType.Video],
    storyFilter: StoryFilter.Include,
    categoryId,
  }
  const { data, fetchMore, networkStatus } = useQuery<
    GalleryPostsQuery,
    GalleryPostsQueryVariables
  >(GALLERY_POSTS, {
    variables,
    fetchPolicy: 'cache-first',
    nextFetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
  })
  const isNextFetch = !!data?.artist?.posts

  const pageInfo = data?.artist?.posts?.pageInfo

  const fetchMorePosts = async () => {
    if (pageInfo && pageInfo.hasNextPage) {
      await fetchMore({
        variables: {
          artistId,
          // NOTE: utoniqPaginationのmerge処理に必要なため残す
          pageInput: {
            cursor: pageInfo.endCursor || null,
            limit: 15,
          },
          pageInputById: {
            cursor: pageInfo.endCursor || null,
            limit: 15,
          },
        },
      })
    }
  }

  const nodes =
    data?.artist?.posts?.edges
      ?.map(({ node }) => node)
      // NOTE YouTube動画は対象外とする
      .filter(node => node.resource?.uri !== null) || []

  return {
    state: {
      posts: nodes,
      loading: networkStatus === NetworkStatus.loading && !isNextFetch,
      refetching: networkStatus === NetworkStatus.fetchMore,
      hasNextPage: !!pageInfo?.hasNextPage,
    },
    actions: {
      onFetchMore: fetchMorePosts,
    },
  }
}

const GALLERY_POSTS = gql`
  query GalleryPosts(
    $artistId: ID!
    $pageInput: PageInputDate
    $pageInputById: PageInput
    $resourceTypes: [PostType!]
    $storyFilter: StoryFilter!
    $categoryId: String
  ) {
    artist(id: $artistId) {
      id
      displayName
      postCategory {
        id
        categories {
          id
          name
          description
          createdAt
          updatedAt
        }
      }
      posts(
        pageInput: $pageInput
        pageInputById: $pageInputById
        resourceTypes: $resourceTypes
        storyFilter: $storyFilter
        categoryId: $categoryId
      ) {
        ...GalleryPosts
      }
      currentLive {
        id
      }
      totalUnreadMentionCount
    }
    user {
      ...CurrentUser
    }
  }
  ${GalleryPostsFragmentDoc}
  ${CurrentUserFragmentDoc}
`
